import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import styles from './donate_button.less'
import { getI18n } from 'client/i18n'
import { Button } from '@paypalcorp/pp-react'
import { trackClick } from '../../../../lib/fpti_analytics'
import { INSTRUMENT_EVENTS, INSTRUMENT_TAGS } from 'shared/shared_consts'

const i18n = getI18n('components/donate_button')
class DonateButton extends React.Component {
  static propTypes = {
    campaign: PropTypes.object,
    canChipIn: PropTypes.bool,
    canDonate: PropTypes.bool,
    createDNWTransaction: PropTypes.func,
    onClick: PropTypes.func,
    preview: PropTypes.bool,
  }

  handleClick = e => {
    const { campaign } = this.props
    trackClick({
      clickName: INSTRUMENT_TAGS.DONATE,
      data: {
        event_name: INSTRUMENT_EVENTS.DW_GIVING_DETAIL_DONATE_PRESSED,
        charityname: campaign.charity && campaign.charity.name,
        crid: campaign.charity && campaign.charity.nonprofit_id,
      },
    })
    this.props.createDNWTransaction({ campaignId: campaign.id })
  }

  render() {
    if (this.props.preview) {
      return (
        <Button
          branded
          data-pa-click="donate"
          data-nemo="donate"
          styleName="donate-button preview"
        >
          {i18n('donate')}
        </Button>
      )
    } else if (!this.props.canDonate || !this.props.canChipIn) {
      return null
    } else {
      return (
        <>
          <Button
            branded
            data-nemo="donate"
            styleName="donate-button"
            onClick={this.handleClick}
          >
            {i18n('donate')}
          </Button>
          <div id="donate-button-cdn" />
        </>
      )
    }
  }
}

export default cssModules(DonateButton, styles, { allowMultiple: true })
